import CreativeFolder from './CreativeFolder';

export default CreativeFolder;
